module.exports = __webpack_public_path__ + "static/media/processing-status.c5f680e8.svg";